<mat-card class="card-block">
    <mat-card-header>
        <mat-card-title>Webbgrupper</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <table class="table user-roles" *ngIf="user.webTeamMemberships?.length">
            <tr *ngFor="let m of user.webTeamMemberships">
                <td>{{ m.webTeam.name }}{{ m.webTeam.category ? ' (' +
                    m.webTeam.category + ')' : '' }}</td>
                <td class="delete-button">
                    <button class="btn btn-danger btn-sm btn-outline" (click)="removeWebTeam(m)">
                        Radera
                    </button>
                </td>
            </tr>
        </table>
        <form [formGroup]="form.controls">
            <div class="row">
                <div class="col-12">
                    <select class="form-control" formControlName="webTeamId" (change)="addWebTeam()">
                        <option value="">Lägg till...</option>
                        <option *ngFor="let t of availableTeams()" [value]="t.id">{{ t.name }}{{ t.category ? ' (' +
                            t.category + ')' : '' }}</option>
                    </select>
                </div>
            </div>
            <form-state [form]="form"></form-state>
        </form>
    </mat-card-content>
</mat-card>